import { CSSProperties } from 'react'
import { DropDown, DropDownActions } from '../DropDown'

import {
  Container,
  ContainerSelect,
  Section,
  SectionTitle,
  Item,
  IconContainer,
  ValueContainer,
  LabelContainer,
} from './DropDownAction.styled'

export type Action = {
  key: string
  Icon?: React.ComponentType<any>
  iconColor?: React.CSSProperties['color']
  rowStyle?: React.CSSProperties
  flipIcon?: boolean
  label: string
  children?: (props: DropDownActions) => React.ReactNode
}

export type Section = {
  key: string
  label?: string
  actions: Action[]
}

interface Props {
  disabled?: boolean
  contextMenu?: boolean
  position?: 'left' | 'right'
  sections: Section[]
  onClickAction: (action: Action) => void
  WrappedComponent: (props: DropDownActions) => JSX.Element
  mask?: 'dark' | 'light'
  style?: CSSProperties
  containerWrappedComponentStyle?: CSSProperties
}

export const DropDownAction = (props: Props): JSX.Element => {
  const {
    disabled,
    contextMenu,
    position,
    sections,
    onClickAction,
    WrappedComponent,
    mask = 'dark',
    style,
    containerWrappedComponentStyle,
  } = props

  return (
    <Container style={style}>
      <DropDown
        containerWrappedComponentStyle={containerWrappedComponentStyle}
        position={position}
        disabled={disabled}
        contextMenu={contextMenu}
        WrappedComponent={WrappedComponent}
        dropDownWidth={300}
        WrappedChildren={(WrapperProps) => (
          <ContainerSelect mask={mask}>
            {sections.map((section) => (
              <Section key={section.key}>
                {section.label && <SectionTitle>{section.label}</SectionTitle>}
                {section.actions.map((action) => (
                  <DropDown
                    key={action.key}
                    position="left"
                    disabled
                    WrappedComponent={({ show, hide, display }) => (
                      <Item
                        mask={mask}
                        onClick={() => {
                          if (action.children) {
                            display ? hide() : show()
                          } else {
                            onClickAction(action)
                            WrapperProps.hide()
                          }
                        }}
                        style={action.rowStyle}
                      >
                        {action.Icon && (
                          <IconContainer mask={mask} flipIcon={action.flipIcon}>
                            <action.Icon style={{ width: 20, height: 20, color: action.iconColor }} />
                          </IconContainer>
                        )}

                        <ValueContainer>
                          <LabelContainer>{action.label}</LabelContainer>
                        </ValueContainer>
                      </Item>
                    )}
                    WrappedChildren={(p) => <>{action.children?.(p)}</>}
                  />
                ))}
              </Section>
            ))}
          </ContainerSelect>
        )}
      />
    </Container>
  )
}
